import dayjs from 'dayjs';
import { Typography, DatePicker } from 'antd'

const { RangePicker } = DatePicker
const { Text } = Typography

const DateRangeSelector = ({ fetchStartDate, fetchEndDate, onChange }) => {

  return (
    <>
      <Text type='secondary' style={{ marginBottom: '1em', fontWeight: 'normal' }}>
        Select Date Range
        &nbsp;-&nbsp;<a onClick={() => onChange({ startDate: dayjs().subtract(1, 'month').set('date', 1), endDate: dayjs().set('date', 1).subtract(1, 'day') })}>Last Month</a>
        &nbsp;|&nbsp;<a onClick={() => onChange({ startDate: dayjs().set('date', 1), endDate: dayjs() })}>MTD</a>
        &nbsp;|&nbsp;<a onClick={() => onChange({ startDate: dayjs().subtract(1, 'day'), endDate: dayjs().subtract(1, 'day') })}>Yesterday</a>
        &nbsp;|&nbsp;<a onClick={() => onChange({ startDate: dayjs(), endDate: dayjs() })}>Today</a>
      </Text>
      <RangePicker
        value={[fetchStartDate, fetchEndDate]}
        onChange={e => {

          if (!e) {
            // no records
            onChange({ startDate: null, endDate: null })
            return
          }

          // new records
          onChange({ startDate: e[0], endDate: e[1] });
        }}
      />
    </>
  )
}

export default DateRangeSelector
